import { Button } from '@/components/ui/button';
import { useModal } from '@/hooks/useModal';
import type { StartGameProps } from '../PurchaseModal';
import { useViewTransition } from '@/hooks/useViewTransition';
import { getPriceById } from '@/helpers/storeListings';
import { centsToPrettyDollars } from '@skillscratch/shared-util';

//StartPurchaseBalanceRet

export function PurchaseSuccess({ startGameProps, priceIdProp }: { startGameProps: StartGameProps | undefined, priceIdProp: string | undefined }) {
    const { closeModalWithoutAnimation, closeModal } = useModal();
    const { navigateNormal } = useViewTransition();
    const price = getPriceById(priceIdProp ?? '');

    let cardsSubtext = '';
    let bonusSubtext = '';

    if (price) {
        cardsSubtext = price?.totalCards > 1 ? 'cards' : 'card';
        bonusSubtext = price?.bonus > 0 ? ` and ${centsToPrettyDollars(price?.bonus, 'round')} bonus` : '';
    }

    const subtext = price ? `${price?.totalCards} ${cardsSubtext} ${bonusSubtext} added to your account` : '';

    const onClickHandler = () => {
        if (!startGameProps) {
            return;
        }
        const { startGameRet, unplayedCard } = startGameProps;

        navigateNormal("/game", {
            replace: false,
            viewTransition: true,
            state: {
                gamePackId: unplayedCard.id,
                gameThemeId: unplayedCard.gameThemeId,
                cardCount: unplayedCard.count,
                startGameRet,
            },
        })
        closeModalWithoutAnimation();
    }

    return (
        <div className="px-7 pt-5 h-full flex flex-col justify-between">
            <div>
                <Button 
                className="py-7 bg-blue text-white text-2xl font-bold w-full rounded-lg mb-4"
                shine
                onClick={() => onClickHandler()}
                >
                    Start scratching!
                </Button>
                <p className="text-center text-lg text-gray-400 opacity-70 font-semibold px-4 mt-6">
                    {subtext}
                </p>
            </div>
            <Button 
                className="bg-gray-50 text-gray-300 text-xl font-bold w-1/2 rounded-lg shadow-none mx-auto"
                size='lg'
                onClick={() => closeModal()}
            >
                Go home
            </Button>
        </div>
    );
}